class ConfigRepository {
  constructor(getState) {
    this.getState = getState
  }

  getStateConfig(key) {
    try {
      const state = this.getState()
      return state?.configReducer[key]?.data
    } catch (e) {
      console.log(e)
      return null
    }
  }
}

export default ConfigRepository
